namespace $.$$ {

	$mol_style_define( $bog_merchquarium_counter, {
		alignItems: 'center',
		flex: { wrap: 'nowrap' },
		border: {
			radius: $mol_gap.round,
		},
		boxShadow: `inset 0 0 0 1px ${ $mol_theme.line }`,

		Value: {
			minWidth: '2.5rem',
			justifyContent: 'center',
			font: {
				weight: 'bold',
			},
		},
	} )

}
